class CustomCollections extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.insertIntoContent();
  }

	insertIntoContent() {
    const type = this.dataset.type; // Get the type, e.g., "[STERREN]"
    if (!type) return;

    const contentContainer = document.querySelector('.js-change-content');
    if (!contentContainer) return;

    const customElement = this; // The current <custom-collections> element
    let replaced = false;

    // Use a TreeWalker to go through all text nodes inside .js-change-content
    const walker = document.createTreeWalker(contentContainer, NodeFilter.SHOW_TEXT, null, false);

    let node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.includes(type)) {
        const parent = node.parentNode;

        // Create a wrapper for the custom element
        const wrapper = document.createElement('div');
        wrapper.innerHTML = customElement.innerHTML;

        // Replace the text node with the custom element
        const replacedText = node.nodeValue.replace(type, '').trim();
        node.nodeValue = replacedText;

        parent.insertBefore(wrapper, node.nextSibling);
        replaced = true;
        break; // Stop after the first match to prevent multiple insertions
      }
    }

    if (replaced) {
      customElement.remove(); // Remove the original hidden <custom-collections> element
    }
  }
}

// Define the custom element
customElements.define('custom-collections', CustomCollections);
